import React from "react";

import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import styles from "./HomeItem.module.css";
import pdf from "../../assets/CV_GuidoEGreco.pdf";

const HomeItem = () => {
  return (
    <div className={styles.home__container}>
      <div className={styles.homeImg} id="home">
        <img
          src="https://res.cloudinary.com/dcegpqqjc/image/upload/v1641837924/CVFotoPortfolio_zifruy.png"
          alt="Guido Greco"
          className={styles.imgCv}
        />
      </div>
      <div className={styles.circulo}></div>
      <div className={styles.semicirculo}></div>
      <div className={styles.homeData}>
        <h1 className={styles.homeName}>Hello! I'm Guido Greco.</h1>
        <p className={styles.homeDesc}>
          A front end developer using React JS and React Native as libraries for
          my apps.
        </p>
        <div className={styles.btnGroup}>
          <button className={styles.homeHire}>
            <a href="mailto:greco.guido@hotmail.com?subject=Project/Job Proposition">
              Hire Me
            </a>
          </button>
          <button className={styles.homeCv}>
            <a href={pdf} download>
              My Resumé
            </a>
          </button>
        </div>
        <div className={styles.gitIcon}>
          <a
            className={styles.linkGithub}
            href="https://github.com/malks14?tab=repositories"
            target="_blank"
            rel="noopener noreferrer"
          >
            <GitHubIcon fontSize="50" />
          </a>
          <a
            className={styles.linkLinkedin}
            href="https://www.linkedin.com/in/guido-greco14"
            target="_blank"
            rel="noopener noreferrer"
          >
            <LinkedInIcon fontSize="50" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default HomeItem;
